import { render, staticRenderFns } from "./DeliverySltInt.vue?vue&type=template&id=37d88eb9&scoped=true&"
import script from "./DeliverySltInt.vue?vue&type=script&lang=js&"
export * from "./DeliverySltInt.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySltInt.vue?vue&type=style&index=0&id=37d88eb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d88eb9",
  null
  
)

export default component.exports